import store from '@/store'
import { trans } from '../prototypes/trans'

export const money = (value: string | number, ignoreCurrency = false): string => {
  if (!value && value !== 0) {
    return ''
  }
  value = String(Number(value) / 100).replace('.', ',')
  value = !value.includes(',') ? `${value},00` : value
  value = value.split(',')[1].length === 1 ? `${value}0` : value

  if (!ignoreCurrency) {
    const currency = store.getters['setup/getAppConfiguration'].currency.toLowerCase() || 'eur'
    return trans(currency, { value })
  }

  return value
}
